/* global grecaptcha */

class Recaptcha {
  constructor (options) {
    this.postmate = options.postmate
    this.holder = options.holder
    this.wrapperClass = options.wrapperClass
    this.scriptId = 'recaptcha-js'

    this.wrapper = null

    this.language = 'en'

    this.init = this.init.bind(this)
    this.successCallback = this.successCallback.bind(this)
    this.injectLibrary = this.injectLibrary.bind(this)
    this.createWrapper = this.createWrapper.bind(this)
    this.runVerification = this.runVerification.bind(this)
  }

  successCallback (token) {
    this.postmate.call('setOverlayResponse', {
      recaptcha: {
        token
      }
    })
  }

  injectLibrary (language) {
    return new Promise((resolve) => {
      const sameLanguage = !language || this.language === language
      if (typeof grecaptcha !== 'undefined' && sameLanguage) {
        resolve()
      }

      window.recaptchaLoaded = () => resolve()

      const recaptchaScript = document.getElementById(this.scriptId)

      if (!sameLanguage) {
        this.language = language
        recaptchaScript.parentNode.removeChild(recaptchaScript)
      }

      if (!recaptchaScript || !sameLanguage) {
        const firstScript = document.getElementsByTagName('script')[0]
        const recaptchaScript = document.createElement('script')
        recaptchaScript.id = this.scriptId
        recaptchaScript.src = `https://www.google.com/recaptcha/api.js?onload=recaptchaLoaded&render=explicit&hl=${this.language}`
        recaptchaScript.async = true
        recaptchaScript.defer = true
        firstScript.parentNode.insertBefore(recaptchaScript, firstScript)
      }
    })
  }

  createWrapper () {
    this.wrapper = this.holder.querySelector(`.${this.wrapperClass}`)

    if (!this.wrapper) {
      this.wrapper = document.createElement('div')
      this.wrapper.classList.add(this.wrapperClass)
      this.holder.appendChild(this.wrapper)
    }
  }

  init () {
    this.injectLibrary()
    this.createWrapper()

    this.postmate.on('hideRecaptcha', () => {
      this.wrapper.classList.add('hidden')
    })

    this.postmate.on('runRecaptcha', (options) => {
      this.injectLibrary(options.language).then(() => {
        this.runVerification(options)
      })
    })
  }

  runVerification (options) {
    this.wrapper.classList.remove('hidden')

    let instancePresent

    // There is no check utility for recaptcha presence, but getResponse fails if no instances are registered
    try {
      grecaptcha.getResponse()
      instancePresent = true
    } catch (error) {
      if (error) {
        instancePresent = false
      }
    }

    if (instancePresent) {
      grecaptcha.reset()
    } else {
      grecaptcha.render(this.wrapper, {
        sitekey: options.sitekey,
        theme: options.theme,
        size: options.size,
        tabindex: options.tabindex,
        callback: this.successCallback
      })
    }
  }
}

export default Recaptcha



// WEBPACK FOOTER //
// ./src/utils/recaptcha.js